<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<main role="main">
    <h2>{{ 'footer.legacy' | translate }}</h2>
    <section class="infoBox" legal-content></section>
    <section>
        <p>
            <a (click)="back()" class="k-button">back</a>
        </p>
    </section>
</main>